export default __webpack_public_path__ + "static/media/medis.865dacad.png";